import { Injectable } from "@angular/core";
import { CommonService } from "../common.service";

export interface Menu {
  state: string;
  name: string;
  type: string;
  iconUrl: string;
  iconUrlActive: string;
}

const MENUITEMS = [
  {
    state: "dashboard",
    name: "Dashboard",
    iconUrl: "assets/images/dashboard_nonactive.svg",
    type: "link",
    iconUrlActive: "assets/images/dashboard_selected.svg",
  },
  {
    state: "users",
    name: "Users",
    iconUrl: "assets/images/user-black.svg",
    type: "link",
    iconUrlActive: "assets/images/user_white.svg",
  },
  //  { state: 'cards', name: 'Cards', iconUrl:"assets/images/Dashboard_icon.svg", type: 'link', iconUrlActive:'assets/images/Dashboard_icon_white.svg'},
  {
    state: "manager",
    name: "Manager",
    iconUrl: "assets/images/manager.svg",
    type: "link",
    iconUrlActive: "assets/images/manager_active.svg",
  },
  {
    state: "setting",
    name: "Settings",
    iconUrl: "assets/images/setting_black.svg",
    type: "link",
    iconUrlActive: "assets/images/setting_white.svg",
  },
];

@Injectable()
export class MenuItems {
  userData;

  constructor(private commonService: CommonService) {
    // this.userData = this.commonService.getUser();
    this.getMenuitem();
  }
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}
